import { redirectAnonymousUsers } from 'containers/auth-redirect-hocs'
import FounderProfilePage from 'containers/founder-profile'

const FounderProfilePageProtected = redirectAnonymousUsers(FounderProfilePage, '/login')
export default FounderProfilePageProtected

export const getStaticProps = async () => ({
  props: {
    pageTitle: 'Founder Profile',
  },
})
